import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { isServer } from '@common/helpers/detection';
import { pathUserHasLimitedAccessTo } from '@common/helpers/userAccessPathMapper';
import { useRedirect } from '@common/hooks/useRedirect';
import { getUser } from '@store/auth';
import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export function useRedirectUserWithLimitedAccess() {
  const {
    currentUser: { emailVerified, appealStatus, emailLastVerifiedAt },
    isAuthenticated
  } = useAppSelector(getUser);
  const { countryCode } = useAppSelector(getLocalisation);
  const { pathname: currentPath } = useLocation();
  const { redirect } = useRedirect();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const path = pathUserHasLimitedAccessTo({
      countryCode,
      userDetails: { emailVerified, appealStatus, emailLastVerifiedAt }
    });

    if (path) {
      const match = matchPath(currentPath, path);

      // On SSR, the router.location.pathname is "/" regardless of actual path, so cannot be trusted for matching.
      // if page needs to redirect, it will still redirect correctly once user actually lands on frontend in browser
      const isUserNotOnAllowedPath = !(match && match.isExact) && !isServer();

      if (isUserNotOnAllowedPath) {
        redirect(path)();
      }
    }
  }, [
    redirect,
    appealStatus,
    countryCode,
    currentPath,
    emailVerified,
    isAuthenticated,
    emailLastVerifiedAt
  ]);
}
